/**
 * 获取当前窗口或 shell 父窗口的 ssclient。
 */
export const getClientTool = () => {
    if (window.ssclient && window.ssclient.versions) {
        return window.ssclient;
    }

    // 跨域 iframe(如第三方 SSO 嵌入到 app-scrm.cainiao.com 等)访问 window.parent 任意属性会被
    // 浏览器同源策略阻断,抛 SecurityError;try/catch 兜底,避免中断 chunk 初始化与下游 isClient 链路。
    try {
        if (window.parent !== window && window.parent.ssclient && window.parent.ssclient.versions) {
            return window.parent.ssclient;
        }
    } catch {
        // cross-origin parent (e.g. 第三方 SSO 嵌入): 父窗口非同源 ssclient 桌面端,直接走 undefined 分支
    }

    return undefined;
};

/**
 * 是否为桌面版。
 */
export const isClient = () => Boolean(getClientTool());

/**
 * 动态代理 ssclient，避免模块加载时拿到空对象。
 */
export const clientTool = new Proxy({} as any, {
    get(_target, prop: string | symbol) {
        const ssclient = getClientTool();

        if (!ssclient) {
            return undefined;
        }

        const value = ssclient[prop];

        if (typeof value === 'function') {
            return value.bind(ssclient);
        }

        return value;
    },
});

/**
 * 根据 UA 判断当前应用是否为桌面端版本。
 */
export const desktopMajorVersion = () => {
    const ua = window.navigator.userAgent.toLowerCase();

    if (isClient() && ua) {
        if (ua.indexOf('salesmartly-desktop/1') > -1) {
            return 'v1';
        }
        if (ua.indexOf('salesmartly-desktop/2') > -1) {
            return 'v2';
        }
    }

    return '';
};
